import React, { FC } from 'react';
import {Alert} from './AlertComponent';
import {LanguageManager} from '../Language.service.ts';

interface ErrorProps {
  message: string;
  defaultValue: string;
  severity: string;
  display: boolean;
  onClose: ()=>void;
  languageManager: LanguageManager;
  replacement?: string;
}


const ErrorMessage: FC<ErrorProps> = (errorProps: ErrorProps) => {
  const { message, defaultValue, severity, display, onClose, languageManager, replacement } = errorProps;
  
  return (
    display && (
      <div className="AlertMessageWrapper">
        <Alert size="small" severity={severity} variant="open" heading={getHeading()} closable="true" onClose={onClose} />
      </div>
    )
  );

  function getHeading(): React.SetStateAction<string> {
    if (!languageManager) {
      console.log(`Language manager not available.`);
      return defaultValue;
    }
    console.log(languageManager.ready ? `Getting error message from language manager.` : `Using default value.`);
    return replacement ? languageManager.getPhraseWithReplacement(message, replacement, defaultValue) : languageManager.getPhrase(message, defaultValue);
  }
};

export default ErrorMessage;
